module.exports = __webpack_public_path__ + "img/cruise-distance.8535f111.svg";